var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_Trash",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.556,
    height: 20,
    viewBox: "0 0 15.556 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon_Trash-2",
    "data-name": "icon_Trash",
    d: "M1.111,17.778A2.229,2.229,0,0,0,3.333,20h8.889a2.229,2.229,0,0,0,2.222-2.222V4.444H1.111ZM3.844,9.867,5.411,8.3l2.367,2.356L10.133,8.3,11.7,9.867,9.344,12.222,11.7,14.578l-1.567,1.567L7.778,13.789,5.422,16.144,3.856,14.578l2.356-2.356Zm7.822-8.756L10.556,0H5L3.889,1.111H0V3.333H15.556V1.111Z",
    fill: "#982727"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon_Trash.cc702a06da5bd1843281d44f50378eb6.svg";
export { ForwardRef as ReactComponent };